import {
    Alert,
    Button,
    Card,
    Col,
    Form,
    Input,
    InputNumber,
    Modal,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import {
    DeleteOutlined,
    EditOutlined,
    InfoCircleOutlined,
    PlusOutlined,
    ReloadOutlined,
    SearchOutlined,
    EyeOutlined,
    SettingOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { apiCall } from "../../API/RestApi";
import { useSelector } from "react-redux";

function DrawSetting() {
    const token = useSelector((state) => state.user.token);

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [dataModal, setDataModal] = useState(null);
    const [isModal, setIsModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState("");

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const headers = {
        Authorization: "Bearer " + token,
    };

    const formatRupiah = (value) => {
        if (value === null || value === undefined || value === "") return "-";
        return `Rp ${Number(value).toLocaleString("id-ID")}`;
    };

    const columns = [
        {
            title: "No",
            key: "no",
            width: 70,
            render: (_, record, index) =>
                (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
        },
        {
            title: (
                <Tooltip title="Nama rule/promo untuk pengaturan spin. Contoh: Promo Harbolnas, Promo Ramadhan, Default Spin.">
                    Nama Setting <InfoCircleOutlined />
                </Tooltip>
            ),
            dataIndex: "name",
            key: "name",
            render: (text) => <b>{text}</b>,
        },
        {
            title: (
                <Tooltip title="Minimal pembelian untuk mendapatkan spin. Contoh: Rp300.000 = 1x spin per kelipatan Rp300.000.">
                    Min Pembelian <InfoCircleOutlined />
                </Tooltip>
            ),
            dataIndex: "min_purchase_amount",
            key: "min_purchase_amount",
            render: (text) => formatRupiah(text),
        },
        {
            title: (
                <Tooltip title="Jumlah spin yang didapat setiap memenuhi kelipatan minimal pembelian. Biasanya diisi 1.">
                    Spin Per Amount <InfoCircleOutlined />
                </Tooltip>
            ),
            dataIndex: "spin_per_amount",
            key: "spin_per_amount",
            width: 160,
            render: (text) => <Tag color="purple">{text || 1}x</Tag>,
        },
        {
            title: (
                <Tooltip title="Batas maksimal spin dari satu kode. Kosong/null berarti tidak dibatasi.">
                    Max Spin / Code <InfoCircleOutlined />
                </Tooltip>
            ),
            dataIndex: "max_spin_per_code",
            key: "max_spin_per_code",
            width: 160,
            render: (text) =>
                text ? <Tag color="orange">{text}x</Tag> : <Tag>Unlimited</Tag>,
        },
        {
            title: (
                <Tooltip title="Active berarti setting bisa dipakai untuk generate draw code. Inactive berarti tidak dipakai.">
                    Status <InfoCircleOutlined />
                </Tooltip>
            ),
            dataIndex: "status",
            key: "status",
            width: 120,
            render: (text) =>
                text === "active" ? (
                    <Tag color="green">Active</Tag>
                ) : (
                    <Tag color="red">Inactive</Tag>
                ),
        },
        {
            title: "Action",
            key: "action",
            width: 140,
            fixed: "right",
            render: (_, record) => (
                <Space>

                    <Tooltip title="Lihat detail setting">
                        <Button
                            onClick={() => openDetail(record)}
                            icon={<EyeOutlined />}
                        />
                    </Tooltip>

                    <Tooltip title="Ubah data setting">
                        <Button
                            type="primary"
                            onClick={() => openModal("edit", record)}
                            icon={<EditOutlined />}
                        />
                    </Tooltip>

                    <Tooltip title="Nonaktifkan setting">
                        <Button
                            danger
                            type="primary"
                            onClick={() => modalDeleteData(record)}
                            icon={<DeleteOutlined />}
                        />
                    </Tooltip>

                </Space>
            ),
        }
    ];

    useEffect(() => {
        getData();
    }, [JSON.stringify(page), search, status]);

    const getData = () => {
        setLoading(true);

        let url =
            "/draw-setting?search=" +
            encodeURIComponent(search) +
            "&page=" +
            page.pagination.current +
            "&limit=" +
            page.pagination.pageSize;

        if (status !== "") {
            url += "&status=" + status;
        }

        apiCall({
            method: "GET",
            url,
            data: {
                headers,
            },
        })
            .then((res) => {
                if (res.status === 200) {
                    setData(res.data.rows || []);
                    setPage({
                        ...page,
                        pagination: {
                            ...page.pagination,
                            total: res.data.count || 0,
                        },
                    });
                }

                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
            });
    };

    const openModal = (type, record = null) => {
        setDataModal(null);
        form.resetFields();

        if (type === "edit") {
            setDataModal(record);

            form.setFieldsValue({
                name: record.name,
                min_purchase_amount: Number(record.min_purchase_amount || 0),
                spin_per_amount: Number(record.spin_per_amount || 1),
                max_spin_per_code: record.max_spin_per_code
                    ? Number(record.max_spin_per_code)
                    : null,
                status: record.status || "active",
            });
        } else {
            form.setFieldsValue({
                spin_per_amount: 1,
                max_spin_per_code: null,
                status: "active",
            });
        }

        setIsModal(true);
    };

    const closeModal = () => {
        setIsModal(false);
        setDataModal(null);
        form.resetFields();
    };

    const modalDeleteData = (record) => {
        Modal.confirm({
            title: "Nonaktifkan Draw Setting",
            content: `Anda ingin menonaktifkan setting "${record.name}"?`,
            okText: "Nonaktifkan",
            cancelText: "Batal",
            okButtonProps: {
                danger: true,
            },
            onOk: () => postApi("DELETE", record),
        });
    };

    const postApi = (method, values) => {
        setLoading(true);

        let url = "/draw-setting";

        if (method === "PUT") {
            url = "/draw-setting/" + dataModal.draw_setting_id;
        }

        if (method === "DELETE") {
            url = "/draw-setting/" + values.draw_setting_id;
        }

        apiCall({
            method,
            url,
            data: {
                data: values,
                headers,
            },
        })
            .then((res) => {
                setLoading(false);

                if (res.status === 200) {
                    setIsAlert(true);
                    setTextAlert(res.message || "Data berhasil disimpan");
                    closeModal();
                    getData();
                } else {
                    Modal.error({
                        title: "Gagal",
                        content: res.message || "Data gagal disimpan",
                    });
                }
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
            });
    };

    const onFinish = (values) => {
        const payload = {
            name: values.name,
            min_purchase_amount: values.min_purchase_amount,
            spin_per_amount: values.spin_per_amount,
            max_spin_per_code: values.max_spin_per_code || null,
            status: values.status,
        };

        if (dataModal) {
            postApi("PUT", payload);
        } else {
            postApi("POST", payload);
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    const openDetail = (record) => {
  Modal.info({
    title: "Detail Draw Setting",
    width: 500,
    content: (
      <div style={{ marginTop: 12 }}>
        <p>
          <b>Nama Setting:</b> {record.name}
        </p>

        <p>
          <b>Min Pembelian:</b> {formatRupiah(record.min_purchase_amount)}
        </p>

        <p>
          <b>Spin Per Amount:</b> {record.spin_per_amount || 1}x
        </p>

        <p>
          <b>Max Spin Per Code:</b>{" "}
          {record.max_spin_per_code
            ? `${record.max_spin_per_code}x`
            : "Unlimited"}
        </p>

        <p>
          <b>Status:</b>{" "}
          {record.status === "active" ? "Active" : "Inactive"}
        </p>

        <hr />

        <p>
          <b>Rumus:</b>
          <br />
          floor(total pembelian / min pembelian) × spin per amount
        </p>

        <p>
          <b>Contoh:</b>
          <br />
          Pembelian Rp920.000 dengan min Rp300.000 → 3x spin
        </p>
      </div>
    ),
  });
};

    return (
        <>
            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}

            <Card
                title={
                    <Space>
                        <SettingOutlined />
                        <b>Master Draw Setting</b>
                        <Tooltip title="Master setting digunakan untuk menentukan minimal pembelian, jumlah spin per kelipatan, dan batas maksimal spin per kode.">
                            <InfoCircleOutlined />
                        </Tooltip>
                    </Space>
                }
                extra={
                    <Space>
                        <Tooltip title="Refresh data setting">
                            <Button onClick={getData}>
                                <ReloadOutlined /> Refresh
                            </Button>
                        </Tooltip>

                        <Tooltip title="Tambah setting baru untuk aturan spin">
                            <Button type="primary" onClick={() => openModal("add")}>
                                <PlusOutlined /> Tambah Setting
                            </Button>
                        </Tooltip>
                    </Space>
                }
            >
                <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                    <Col xs={24} md={10}>
                        <Tooltip title="Cari berdasarkan nama setting">
                            <Search
                                placeholder="Cari nama setting..."
                                allowClear
                                enterButton={<SearchOutlined />}
                                onSearch={searchData}
                            />
                        </Tooltip>
                    </Col>

                    <Col xs={24} md={6}>
                        <Tooltip title="Filter status setting">
                            <Select
                                allowClear
                                placeholder="Filter status"
                                style={{ width: "100%" }}
                                onChange={(value) => {
                                    setStatus(value || "");
                                    setPage({
                                        pagination: {
                                            current: 1,
                                            pageSize: 10,
                                        },
                                    });
                                }}
                                options={[
                                    { value: "active", label: "Active" },
                                    { value: "inactive", label: "Inactive" },
                                ]}
                            />
                        </Tooltip>
                    </Col>
                </Row>

                <Table
                    rowKey="draw_setting_id"
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={page.pagination}
                    onChange={handleTableChange}
                    scroll={{ x: 1200 }}
                />
            </Card>

            <Modal
                title={
                    <Space>
                        {dataModal ? "Ubah Draw Setting" : "Tambah Draw Setting"}
                        <Tooltip title="Setting ini akan dipakai saat generate draw code. Jumlah spin dihitung dari total pembelian / minimal pembelian.">
                            <InfoCircleOutlined />
                        </Tooltip>
                    </Space>
                }
                open={isModal}
                onOk={form.submit}
                onCancel={closeModal}
                okText="Simpan"
                cancelText="Batal"
                width={720}
                confirmLoading={loading}
            >
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="name"
                                label={
                                    <Tooltip title="Nama setting atau nama promo. Contoh: Default Spin Rp300.000, Promo Ramadhan, Promo Harbolnas.">
                                        Nama Setting <InfoCircleOutlined />
                                    </Tooltip>
                                }
                                rules={[
                                    { required: true, message: "Nama setting wajib diisi!" },
                                    { min: 3, message: "Nama setting minimal 3 karakter!" },
                                ]}
                            >
                                <Input placeholder="Contoh: Default Spin Rp300.000" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                name="min_purchase_amount"
                                label={
                                    <Tooltip title="Minimal pembelian untuk mendapatkan spin. Contoh Rp300.000 berarti setiap kelipatan Rp300.000 akan mendapat spin.">
                                        Min Pembelian <InfoCircleOutlined />
                                    </Tooltip>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message: "Min pembelian wajib diisi!",
                                    },
                                    {
                                        type: "number",
                                        min: 1,
                                        message: "Min pembelian harus lebih dari 0!",
                                    },
                                ]}
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    min={1}
                                    placeholder="Contoh: 300000"
                                    formatter={(value) =>
                                        `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                                    }
                                    parser={(value) => value.replace(/Rp\s?|(\.*)/g, "")}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                name="spin_per_amount"
                                label={
                                    <Tooltip title="Jumlah spin yang diberikan setiap memenuhi kelipatan minimal pembelian. Contoh: 1 berarti Rp300.000 = 1 spin.">
                                        Spin Per Amount <InfoCircleOutlined />
                                    </Tooltip>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message: "Spin per amount wajib diisi!",
                                    },
                                    {
                                        type: "number",
                                        min: 1,
                                        message: "Spin per amount minimal 1!",
                                    },
                                ]}
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    min={1}
                                    placeholder="Contoh: 1"
                                    addonAfter="spin"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                name="max_spin_per_code"
                                label={
                                    <Tooltip title="Batas maksimal spin dari satu kode. Kosongkan jika tidak ingin membatasi spin.">
                                        Max Spin Per Code <InfoCircleOutlined />
                                    </Tooltip>
                                }
                                rules={[
                                    {
                                        type: "number",
                                        min: 1,
                                        message: "Max spin harus lebih dari 0!",
                                    },
                                ]}
                            >
                                <InputNumber
                                    style={{ width: "100%" }}
                                    min={1}
                                    placeholder="Kosongkan jika unlimited"
                                    addonAfter="spin"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item
                                name="status"
                                label={
                                    <Tooltip title="Active berarti setting bisa dipilih saat generate draw code. Inactive berarti tidak digunakan.">
                                        Status <InfoCircleOutlined />
                                    </Tooltip>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message: "Status wajib dipilih!",
                                    },
                                ]}
                                initialValue="active"
                            >
                                <Select
                                    options={[
                                        { value: "active", label: "Active" },
                                        { value: "inactive", label: "Inactive" },
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}

export default DrawSetting;